import { render, staticRenderFns } from "./c_wechat_live.vue?vue&type=template&id=4f5ccf65&scoped=true&"
import script from "./c_wechat_live.vue?vue&type=script&lang=js&"
export * from "./c_wechat_live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ccf65",
  null
  
)

export default component.exports